export default class Sequence {
  constructor(deepstream, store) {
    this.deepstream = deepstream;
    this.store = store;
    this.client = deepstream.client;
  }

  async getSequenceByID(id) {
    const data = await this.deepstream.send("consumer-session", {
      method: "GET_SEQUENCE_BY_ID",
      sequence_id: id
    });
    // data.map(meeting => console.log(meeting.agent_id))
    this.store.commit("sequence/sequence", data);
  }
}
